import React from "react";
// mismas tarjetas, formulario y títulos que Catálogos y Usuarios
import style from "../../scss/Catalogos.module.scss";
import CambiarPasswordComponent from "./component/CambiarPasswordComponent";
import AccesoBiometricoComponent from "./component/AccesoBiometricoComponent";
import { obtenerUsername } from "../../utils/sesion";

// Perfil del usuario en sesión (admin o digitador): contraseña y acceso biométrico
const PerfilPages = () => (
  <div className={`container ${style.catalogos}`}>
    <h1 className={style.encabezado}>Mi perfil</h1>
    <p className={style.descripcion}>
      Sesión iniciada como <strong>{obtenerUsername()}</strong>. Cambia tu contraseña y administra el acceso con huella o
      reconocimiento facial.
    </p>

    <div className="row g-4">
      <div className="col-12 col-lg-5">
        <CambiarPasswordComponent />
      </div>
      <div className="col-12 col-lg-7">
        <AccesoBiometricoComponent />
      </div>
    </div>
  </div>
);

export default PerfilPages;
